import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FaqAccordion = ({ faqs, idPrefix = "faq" }) => (
  <Accordion type="single" collapsible className="card-soft divide-y divide-[rgba(40,91,69,0.1)] px-5 sm:px-7" data-testid={`${idPrefix}-accordion`}>
    {faqs.map((f, i) => (
      <AccordionItem key={f.q} value={`${idPrefix}-${i}`} className="border-0">
        <AccordionTrigger className="py-5 text-left text-base font-semibold hover:no-underline" data-testid={`${idPrefix}-trigger-${i}`}>
          <span className="pr-4 text-[15px] font-semibold sm:text-base" style={{ fontFamily: "var(--font-body)", letterSpacing: 0 }}>
            {f.q}
          </span>
        </AccordionTrigger>
        <AccordionContent className="pb-5 text-[15px] leading-relaxed text-muted-foreground">
          <p>{f.a}</p>
          {f.link ? (
            <Link to={f.link.to} className="link-accent mt-2 inline-block text-sm">
              {f.link.label} →
            </Link>
          ) : null}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
